const sizes = {
  container: {
    '2xl': '1366px',
  },
}

export default sizes
